import React from "react";
import { Route, Switch } from "react-router-dom";
import About from "../../pages/About/About";
import Blog from "../../pages/Blog/Blog";
import BlogPostDetail from "../../pages/Blog/BlogPostDetail";
import Portfolio from "../../pages/Portfolio/Portfolio";
import Service from "../../pages/Service/Service";
import Contact from "../../pages/Contact/Contact";

const NavRoutes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <About />
      </Route>
      <Route path="/services">
        <Service />
      </Route>
      <Route path="/projects">
        <Portfolio />
      </Route>
      <Route path="/blogs">
        <Blog />
      </Route>
      <Route path="/blog/:id">
        <BlogPostDetail />
      </Route>
      <Route path="/about">
        <About />
      </Route>
      <Route path="/connect">
        <Contact />
      </Route>
    </Switch>
  );
};

export default NavRoutes;
